<template>
  <div style="height: 100%" ref="echart">询盘数据加载中...</div>
</template>

<script>
import echarts from "echarts"
export default {
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {
          title: {},
          xData: [],
          series: []
        }
      }
    },
    isAxis: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    //这里不能换成箭头函数
    chartOptions() {
      return this.isAxis ? this.axisOption : this.normalOption
    },
    isCollpase() {
      return this.$store.state.login.isCollapse
    }
  },
  watch: {
    //watch数据的变化时执行函数
    chartData: {
      //这里不能换成箭头函数
      handler: function() {
        this.initEchart()
      },
      deep: true
    },
    isCollpase() {
      setTimeout(() => {
        this.resizeEchart()
      }, 300)
    }
  },
  data() {
    return {
      echart: null,
      axisOption: {
        legend: {
          textStyle: {
            color: "#333"
          },
          data: ["最后一周询盘量"]
        },
        tooltip: {
          trigger: "axis"
        },
        title: {
          subtext: "最近一周询盘量(所有询盘)",
          left: "center",
          align: "right"
        },
        xAxis: {
          type: "category",
          //   boundaryGap: false,
          data: [],
          axisLine: {
            lineStyle: {
              color: "#17b3a3"
            }
          },
          axisLabel: {
            color: "#333"
          }
        },
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#17b3a3"
              }
            }
          }
        ],
        color: [
          "#2ec7c9",
          "#b6a2de",
          "#5ab1ef",
          "#ffb980",
          "#d87a80",
          "#8d98b3",
          "#e5cf0d",
          "#97b552",
          "#95706d",
          "#dc69aa",
          "#07a2a4",
          "#9a7fd1",
          "#588dd5",
          "#f5994e",
          "#c05050",
          "#59678c",
          "#c9ab00",
          "#7eb00a",
          "#6f5553",
          "#c14089"
        ],
        series: []
      },
      normalOption: {
        title: {
          subtext: "",
          left: ""
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [],
        color: ["#0f78f4", "#dd536b", "#9462e5", "#a6a6a6", "#e1bb22", "#39c362", "#3ed1cf"]
      }
    }
  },

  methods: {
    initEchart() {
      this.initEchartData()
      if (this.echart) {
        this.echart.setOption(this.chartOptions)
      } else {
        this.echart = echarts.init(this.$refs.echart)
        this.echart.setOption(this.chartOptions)
      }
    },
    initEchartData() {
      if (this.isAxis) {
        this.axisOption.xAxis.data = this.chartData.xData
        this.axisOption.series = this.chartData.series
      } else {
        this.normalOption.title = this.chartData.title
        this.normalOption.series = this.chartData.series
      }
    },
    resizeEchart() {
      this.echart ? this.echart.resize() : ""
    }
  },
  mounted() {
    this.initEchart()
    window.addEventListener("resize", this.resizeEchart)
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEchart)
  }
}
</script>

<style></style>
